import { useCallback } from 'react';
import { useForm } from 'react-hook-form';
import { ConsolidationConfig } from '../../core/api/consolidation/types';

export interface SettingsFormValues {
  name: string;
  yearEnd: Date;
  currency: string;
}

export const useSettingsForm = () => {
  const form = useForm<SettingsFormValues>({
    defaultValues: {
      name: '',
      currency: ''
    },
    mode: 'onChange'
  });

  const { clearErrors, control, formState, getValues, setValue, trigger, watch } = form;

  const restoreConfig = useCallback(
    (config: ConsolidationConfig) => {
      setValue('name', config.name, {
        shouldValidate: true,
        shouldDirty: true
      });
      setValue('yearEnd', new Date(config.yearEnd), {
        shouldValidate: true,
        shouldDirty: true
      });
      setValue('currency', config.presentationCurrency);
      clearErrors();
    },
    [clearErrors, setValue]
  );

  return {
    clearErrors,
    control,
    formState,
    getValues,
    restoreConfig,
    setValue,
    trigger,
    watch
  };
};
